import { IBlog, IAuthor } from "./IBlog";
import { authors } from "./blog-posts/authors";
import { blog as blog1 } from "./blog-posts/0_demo";
import sustainableFinancingSrhrDec2025 from "./blog-posts/sustainable-financing-srhr-dec-2025";
import accessAloneIsNotEnough from "./blog-posts/access-alone-is-not-enough";
// import { blog as blog2 } from "./blog-posts/0_demo2";
// import { blog as blog3 } from "./blog-posts/0_demo3";

const blogsRaw: IBlog[] = [
    // blog1,
    accessAloneIsNotEnough,
    sustainableFinancingSrhrDec2025,
];

const formattedBlog = blogsRaw.map((blog) => {
    const slug = blog.slug ? blog.slug : blog.title.toLowerCase().replace(/\s+/g, '-');
    
    // Handle multiple authors via authorKeys array
    let authorsArray: IAuthor[] | undefined;
    if (blog.authorKeys && blog.authorKeys.length > 0) {
        authorsArray = blog.authorKeys
            .map(key => authors[key])
            .filter((author): author is IAuthor => author !== undefined);
    }
    
    // Handle single author via authorKey (for backward compatibility)
    const author = blog.author 
        ? blog.author 
        : blog.authorKey 
            ? authors[blog.authorKey] 
            : undefined;
    
    return { 
        ...blog, 
        slug, 
        author: authorsArray && authorsArray.length > 0 ? undefined : author,
        authors: authorsArray && authorsArray.length > 0 ? authorsArray : undefined
    };
});

// Filter out blogs with future dates and sort by date (newest first)
const today = new Date();
today.setHours(0, 0, 0, 0); // Reset time to start of day for accurate comparison

export const blogs = formattedBlog
    .filter((blog) => {
        const publishedDate = new Date(blog.publishedDate);
        publishedDate.setHours(0, 0, 0, 0);
        return publishedDate <= today;
    })
    .sort((a, b) => {
        const dateA = new Date(a.publishedDate).getTime();
        const dateB = new Date(b.publishedDate).getTime();
        return dateB - dateA; // Newest first (descending order)
    });

export const getBlogBySlug = (slug: string): IBlog | undefined => {
    return blogs.find((blog) => blog.slug === slug);
};

// Get unique article dates sorted (newest first)
export const getUniqueArticleDates = (): string[] => {
    const dates = blogs.map((blog) => blog.publishedDate);
    const uniqueDates = Array.from(new Set(dates));
    return uniqueDates.sort((a, b) => {
        const dateA = new Date(a).getTime();
        const dateB = new Date(b).getTime();
        return dateB - dateA; // Newest first (descending order)
    });
};

// Get unique year-month combinations sorted (newest first)
export const getUniqueYearMonths = (): string[] => {
    const yearMonths = blogs.map((blog) => {
        const date = new Date(blog.publishedDate);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        return `${year}-${month}`;
    });
    const uniqueYearMonths = Array.from(new Set(yearMonths));
    return uniqueYearMonths.sort((a, b) => {
        const dateA = new Date(a + '-01').getTime();
        const dateB = new Date(b + '-01').getTime();
        return dateB - dateA; // Newest first (descending order)
    });
};

// Get unique keywords sorted alphabetically
export const getUniqueKeywords = (): string[] => {
    const allKeywords = blogs.flatMap((blog) => blog.keywords || []);
    const uniqueKeywords = Array.from(new Set(allKeywords));
    return uniqueKeywords.sort((a, b) => a.localeCompare(b)); // Alphabetical order
};
